export default __webpack_public_path__ + "static/media/hht1_song_10.406946c1.png";